import {apiUrl} from "../../components/common/getEnv";

export const fetchCategoryUrl = () => `${apiUrl}/item_quality/categories?listable=1&sort=name`;